<!--
<div [ngSwitch]="isAuthenticated()" class="chart-container">
    <div *ngSwitchCase="true" class="png-chart">
         <span id="home-logged-message" *ngIf="account" [translate]="'home.logged.message'"
                    [translateParams]="{ username: account.username }">You are logged in as user "{{ account.username }}".</span>

    </div>
</div>
-->
<div [ngSwitch]="isAuthenticated()" class="home-dashboard">
  <section class="dashboard-hero">
    <div class="hero-copy">
      <span class="hero-kicker">{{ greetingText }}</span>
      <h1 class="hero-title" [translate]="'global.menu.reports'">Reports</h1>
    </div>
    <div class="hero-orb" aria-hidden="true"></div>
  </section>

  <div class="chart-grid">
    <mat-card class="chart-card chart-card--line">
      <div class="card-head">
        <h3 class="card-title" [translate]="'report.monthlyVisitors'">Monthly visitors</h3>
        <span class="card-accent"></span>
      </div>
      <div class="card-body">
        <app-monthly-visitors class="chart-host"></app-monthly-visitors>
      </div>
    </mat-card>

    <mat-card class="chart-card chart-card--bar">
      <div class="card-head">
        <h3 class="card-title" [translate]="'report.monthlyUniqueVisitor'">
          Monthly unique visitor
        </h3>
        <span class="card-accent"></span>
      </div>
      <div class="card-body">
        <app-monthly-unique-visitor class="chart-host"></app-monthly-unique-visitor>
      </div>
    </mat-card>
  </div>
</div>
